module.exports = __webpack_public_path__ + "img/MY_FAVORITE.170aaedc.png";